import "core-js/modules/es.json.stringify.js";
import vipMixin from "../mixins/vipMixin";
import snoreSettingMixin from "../mixins/snoreSettingMixin";
import { setSnoreSettingInfos } from "../../../utils/api";
export default {
  name: "storageLocation",
  mixins: [vipMixin, snoreSettingMixin],
  data: function data() {
    return {
      activeIcon: require('../../../assets/imgs/snore/checked.png'),
      inactiveIcon: require('../../../assets/imgs/snore/uncheck.png'),
      pageName: 'location'
    };
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.snore.storageMethods"); // 标题国际化
  },
  created: function created() {},
  methods: {
    changeType: function changeType(type) {
      var _this = this;

      this.lastedChecked = this.type;
      var needShowVipDialog = this.getIsNeedVipDialog(type);

      if (type === 'vip' && needShowVipDialog) {
        this.showVipDialog();
      } else {
        this.type = type;
        var value = Object.assign({}, this.settingDetails, {
          type: type,
          days: this.days
        });
        var data = {
          "type": "snore_store",
          "value": JSON.stringify(value)
        };
        setSnoreSettingInfos(data).then(function (res) {
          console.log(res);

          if (res) {
            _this.type = type;
            _this.lastedChecked = type;
          } else {
            _this.type = _this.lastedChecked;
          }
        }).catch(function (e) {
          _this.type = _this.lastedChecked;
        });
      }
    }
  }
};